module.exports = __webpack_public_path__ + "img/Walls_text03_finality.d2ac8fef.png";